// extracted by mini-css-extract-plugin
export var alternate = "_1a-h";
export var black = "_1a-3";
export var blue = "_1a-d";
export var blueLight = "_1a-c";
export var brand = "_1a-7";
export var error = "_1a-9";
export var gray = "_1a-6";
export var grayBlue = "_1a-b";
export var iconWrapper = "_1a-4";
export var indigo = "_1a-e";
export var orange = "_1a-g";
export var pink = "_1a-f";
export var primary = "_1a-0";
export var purple = "_1a-8";
export var success = "_1a-5";
export var warning = "_1a-a";
export var white = "_1a-1";
export var whiteSuccess = "_1a-2";